import cabinetStyle from "./MentorCabinet.module.css";
import Style from "../Style.module.css";
import React, {useState} from "react";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import {InputGroup, FormControl, OverlayTrigger, Tooltip} from "react-bootstrap";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import {trySetTimeout} from "../../hooks/trySetTiemout";
import {useTranslation} from "react-i18next";

function MentorReferralProgramCodeData(props) {
    const { t } = useTranslation('translation', { keyPrefix: 'mentorReferralProgramCodeData' });
    const [linkCopied, setLinkCopied] = useState(false)
    const [l1RefOpened, setL1RefOpened] = useState(false)
    const [l2RefOpened, setL2RefOpened] = useState(false)
    const l2RefJsonKey = "l2_referrals"
    const payoutMessage = t('toGetPaidWrite')

    function copyUrlToClipboard(event) {
        navigator.clipboard.writeText(window.location.host + `/register?ref=${props.code}`);
        setLinkCopied(true)
        trySetTimeout(() => {
            setLinkCopied(false)
        }, 5000)

        event.cancelBubble = true;
        if (event.stopPropagation) event.stopPropagation();
    }

    function resolveReferralL1Header() {
        if (l2RefJsonKey in props) {
            return t('1stLevelReferrals')
        } else {
            return t('referrals')
        }
    }

    function openL1RefOpened() {
        if (l1RefOpened === true) {
            setL1RefOpened(false)
        } else {
            setL1RefOpened(true)
        }
    }

    function openL2RefOpened() {
        if (l2RefOpened === true) {
            setL2RefOpened(false)
        } else {
            setL2RefOpened(true)
        }
    }

    function renderTooltip(text) {
        return (<Tooltip id="button-tooltip">
            {text}
        </Tooltip>)
    }

    return (
        <>
            <div className={`${cabinetStyle.commonTile} ${cabinetStyle.referralGroup}`}>
                <header className={Style.h5Heading}>{t('header')}</header>
                <textarea disabled={true} rows={4} spellCheck={false} className={cabinetStyle.referralCodeConditions}
                          value={props.program_description}/>
                <div className={cabinetStyle.referralLinkComponent}>

                    <InputGroup
                        style={{alignSelf: "center"}}
                    >
                        <InputGroup.Text id="basic-addon3">
                            {t('referralLink')}
                        </InputGroup.Text>
                        <FormControl id="basic-url" aria-describedby="basic-addon3"
                                     value={" " + window.location.host + `/register?ref=${props.code}`}
                                     disabled={true}/>
                    </InputGroup>

                    <div className={`${cabinetStyle.controlsCopy} ${cabinetStyle.controlsCopyReferralLink}`}>
                        <ContentCopyIcon sx={linkCopied ? {color: '#64dd17'} : {color: '#ede7f6'}}
                                         onClick={copyUrlToClipboard}></ContentCopyIcon>
                    </div>
                </div>
                <br></br>
                <div>
                    <div><b>{t('acquired')}</b> {props.total_acquired} €</div>
                    <OverlayTrigger
                        placement="left"
                        delay={{show: 50, hide: 300}}
                        overlay={renderTooltip(payoutMessage)}
                    >
                        <div><b>{t('paidOut')}</b> {props.paid_out} €</div>
                    </OverlayTrigger>
                </div>

                <div className={cabinetStyle.referralList}>
                    <div style={{display: "flex"}}>
                        <div className={Style.h5Heading}>{resolveReferralL1Header()}: {props.l1_referrals.length}</div>
                        <KeyboardArrowDownIcon style={{width: "24px", height: "24px", alignSelf: "right"}}
                                               onClick={openL1RefOpened}></KeyboardArrowDownIcon>
                    </div>
                    {l1RefOpened &&
                        <div>
                            <ul>
                                {props.l1_referrals.map(
                                    (item) => {
                                        return <li>{(item === null || item === "") ? t('noNickname') : item}</li>
                                    }
                                )}
                            </ul>
                        </div>}
                </div>
                {(l2RefJsonKey in props) &&
                    <div className={cabinetStyle.referralList}>
                        <div style={{display: "flex"}}>
                            <div className={Style.h5Heading}>{t('2ndLevelReferrals')} {props.l2_referrals.length}</div>
                            <KeyboardArrowDownIcon style={{width: "24px", height: "24px", alignSelf: "right"}}
                                                   onClick={openL2RefOpened}></KeyboardArrowDownIcon>
                        </div>
                        {l2RefOpened &&
                            <div>
                                <ul>
                                    {props.l2_referrals.map(
                                        (item) => {
                                            return <li>{(item === null || item === "") ? t('noNickname') : item}</li>
                                        }
                                    )}
                                </ul>
                            </div>}
                    </div>
                }

            </div>
        </>

    )
}

export default MentorReferralProgramCodeData